import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';

export const articleManageEvents = {
  certificatesModified: new SimpleEventDispatcher<number>(),
  branchesModified: new SignalDispatcher(),
  tiersAdded: new SignalDispatcher(),
  tierRemoved: new SignalDispatcher(),
  tierUpdated: new SignalDispatcher(),
};
